import { McpChannelsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useContentServiceChannelsAPI(): McpChannelsApi {
  return new McpChannelsApi(apiConfig);
}
